import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';

import Select from 'components/Input/Select';
import YesNoOptions from 'components/Input/YesNoOptions';
import Label from 'components/Label';
import {
    PROFILE_BUYER,
    PROFILE_BUYER_BUY,
    PROFILE_INCENTIVE,
    PROFILE_NEEDS_LOAN_STATUS,
    PROFILE_NEEDS_TO_SELL,
    PROFILE_RESIDENCE_TYPE,
} from 'constants/Global';
import { translate } from 'helpers/Translate';

const NonOwnerQuestions = ({ values, small }) => {
    const containerLabelClasses = classnames({
        'row-container__label': true,
        'row-container__label--small': small,
    });

    const containerFieldClasses = classnames({
        'row-container__field': true,
        'row-container__field--small': small,
    });

    return (
        <div>
            <div className="row-container row-container--padding-bottom">
                <div className={containerLabelClasses}>
                    <Label
                        labelFor="profile_buyer"
                        text={translate('Pour quelle raison estimez-vous ce bien ?')}
                        small={small}
                    />
                </div>
                <div className={containerFieldClasses}>
                    <Field
                        component={Select}
                        name="profile_buyer"
                        options={PROFILE_BUYER}
                        emptyOption
                        small={small}
                    />
                </div>
            </div>
            {values.profile_buyer === PROFILE_BUYER_BUY && (
                <div>
                    <div className="row-container row-container--padding-bottom">
                        <div className={containerLabelClasses}>
                            <Label
                                labelFor="profile_residence_type"
                                text={translate('Ce bien sera')}
                                small={small}
                            />
                        </div>
                        <div className={containerFieldClasses}>
                            <Field
                                component={Select}
                                name="profile_residence_type"
                                options={PROFILE_RESIDENCE_TYPE}
                                emptyOption
                                small={small}
                            />
                        </div>
                    </div>
                    <div className="row-container row-container--padding-bottom">
                        <div className={containerLabelClasses}>
                            <Label
                                labelFor="profile_incentive"
                                text={translate('Vous êtes intéressé par')}
                                small={small}
                            />
                        </div>
                        <div className={containerFieldClasses}>
                            <Field
                                component={Select}
                                name="profile_incentive"
                                options={PROFILE_INCENTIVE}
                                emptyOption
                                small={small}
                            />
                        </div>
                    </div>
                    <div className="row-container row-container--padding-bottom">
                        <div className={containerLabelClasses}>
                            <Label
                                labelFor="profile_needs_loan_status"
                                text={translate('Où en êtes-vous de vos recherches ?')}
                                small={small}
                            />
                        </div>
                        <div className={containerFieldClasses}>
                            <Field
                                component={Select}
                                name="profile_needs_loan_status"
                                options={PROFILE_NEEDS_LOAN_STATUS}
                                emptyOption
                                small={small}
                            />
                        </div>
                    </div>
                    <div className="row-container row-container--padding-bottom">
                        <div className={containerLabelClasses}>
                            <Label
                                labelFor="profile_needs_to_sell"
                                text={translate(
                                    'Projetez-vous de vendre un bien immobilier pour financer votre achat ?',
                                )}
                                small={small}
                            />
                        </div>
                        <div className={containerFieldClasses}>
                            <Field
                                component={Select}
                                name="profile_needs_to_sell"
                                options={PROFILE_NEEDS_TO_SELL}
                                emptyOption
                                small={small}
                            />
                        </div>
                    </div>
                    <div className="row-container row-container--padding-bottom">
                        <div className="row-container__label row-container__label--yes-no">
                            <Label
                                labelFor="profile_needs_loan"
                                text={translate('Souhaitez-vous emprunter ?')}
                                small={small}
                            />
                        </div>
                        <div className="row-container__field row-container__field--yes-no">
                            <YesNoOptions name="profile_needs_loan" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

NonOwnerQuestions.displayName = 'NonOwnerQuestions';

NonOwnerQuestions.propTypes = {
    values: PropTypes.shape({}).isRequired,
    small: PropTypes.bool,
};

/**
 * NonOwnerQuestions Functional Component.
 */
export default NonOwnerQuestions;
